export const COMPARE_AGENT_SCOPE = 'compareAgent';
